import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [statusMsg, setStatusMsg] = useState('');

  const handleSubscribe = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = formData.get('website_alt') as string;
    if (honeypot && honeypot.trim() !== '') {
      setStatus('success');
      setStatusMsg('订阅成功！感谢您的关注。');
      setEmail('');
      return;
    }

    if (!email.trim()) {
      setStatus('error');
      setStatusMsg('请输入有效的邮箱地址。');
      return;
    }

    setStatus('loading');
    try {
      const payload = new URLSearchParams();
      payload.append('email', email);
      formData.forEach((value, key) => {
        if (key !== 'website_alt' && key !== 'email') {
          payload.append(key, value as string);
        }
      });

      const res = await fetch('http://sylbdj.com/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: payload.toString(),
      });
      const responseText = await res.text();
      let parsed: any;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (res.ok && parsed?.code === 'OK') {
        setStatus('success');
        setStatusMsg('订阅成功！感谢您的关注。');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || responseText || '订阅失败，请稍后重试。';
        setStatus('error');
        setStatusMsg(String(serverMsg));
      }
    } catch {
      setStatus('error');
      setStatusMsg('网络错误，请稍后重试。');
    }
  };

  return (
    <footer className="bg-background-900">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          <div className="lg:w-[40%]">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 leading-tight">
              古古漫画
            </h2>
            <p className="font-heading text-xl md:text-2xl text-background-50/80 mt-1">
              简洁 · 极速 · 纯粹
            </p>
            <p className="text-sm text-background-300/70 mt-6 leading-relaxed max-w-md">
              古古漫画网致力于为漫画爱好者提供最优质的在线阅读体验。
              简洁的界面、极速的加载、海量的漫画资源，让您随时随地畅享漫画世界的精彩。
              如有合作意向或问题反馈，欢迎通过邮件联系我们：hello@sylbdj.com
            </p>

            <div className="mt-8">
              <p className="text-xs text-background-300/60 mb-3">订阅更新通知</p>
              <form
                onSubmit={handleSubscribe}
               
                className="flex flex-col gap-3 max-w-sm"
              >
                <input
                  type="text"
                  name="website_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="form-anti-spam"
                />
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="输入您的邮箱地址"
                  required
                  className="bg-transparent border-0 border-b border-background-500/40 pb-2 text-sm text-background-50 placeholder:text-background-400/50 focus:outline-none focus:border-primary-400 transition-colors"
                />
                <button
                  type="submit"
                  disabled={status === 'loading'}
                  className="whitespace-nowrap px-6 py-2 border border-background-300/40 text-sm text-background-200 rounded-md hover:border-primary-400 hover:text-primary-300 transition-colors cursor-pointer disabled:opacity-50 w-fit"
                >
                  {status === 'loading' ? '提交中...' : '订阅'}
                </button>
                {status === 'success' && (
                  <p className="text-xs text-accent-400">{statusMsg}</p>
                )}
                {status === 'error' && (
                  <p className="text-xs text-primary-400">{statusMsg}</p>
                )}
              </form>
            </div>
          </div>

          <div className="lg:w-[60%] grid grid-cols-3 gap-8">
            <div>
              <h3 className="text-sm font-semibold text-background-100 mb-4">快速导航</h3>
              <div className="flex flex-col gap-3">
                <Link to="/" className="text-sm text-background-300/70 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer">首页</Link>
                <Link to="/category" className="text-sm text-background-300/70 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer">漫画分类</Link>
                <Link to="/about" className="text-sm text-background-300/70 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer">关于我们</Link>
              </div>
            </div>
            <div>
              <h3 className="text-sm font-semibold text-background-100 mb-4">热门推荐</h3>
              <div className="flex flex-col gap-3">
                <Link to="/manga/shuumatsu-no-valkyrie" className="text-sm text-background-300/70 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer">终末的女武神</Link>
                <a href="#" className="text-sm text-background-300/70 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer">海贼王</a>
                <a href="#" className="text-sm text-background-300/70 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer">咒术回战</a>
              </div>
            </div>
            <div>
              <h3 className="text-sm font-semibold text-background-100 mb-4">网站信息</h3>
              <div className="flex flex-col gap-3">
                <a href="#" className="text-sm text-background-300/70 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer">更新日志</a>
                <a href="#" className="text-sm text-background-300/70 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer">隐私政策</a>
                <a href="#" className="text-sm text-background-300/70 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer">友情链接</a>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-700/40">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-400/60">
              &copy; {new Date().getFullYear()} 古古漫画网 - 版权所有
            </p>
            <p className="text-xs text-background-400/60">
              本站内容仅供学习交流，请支持正版漫画
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}